module.exports = __webpack_public_path__ + "6d815c827c09e26ebd5dcb5d2069b621.svg";